export const isPastNumberOfDays = (date: Date, noOfDays: number) => {
  const today = new Date();
  const dateToCompareWith =
    noOfDays > 0 ? new Date(today.setDate(today.getDate() + noOfDays)) : today;
  return date.setHours(0, 0, 0, 0) - dateToCompareWith.setHours(0, 0, 0, 0) < 0;
};
